import { Flex, FlexColumn } from '@ubeya/shared-web/components';
import React from 'react';
import styled from 'styled-components';
import { Chip } from '@ubeya/shared-web/components';
import useGetApplicationStatusConfig from './hooks/useGetApplicationStatusConfig';

const StatusChip = styled(Chip)`
  padding: 0 4px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
`;

const StatusCountItem = styled(FlexColumn)`
  align-items: center;
  gap: 4px;

  &:not(:first-child) {
    border-left: 1px solid ${({ theme }) => theme.colors.grey2};
    padding-left: 8px;
  }
`;

const StatusCountValue = styled.div`
  font-size: 12px;
  font-weight: 500;
`;

const StatusCountsWrapper = styled(Flex)`
  flex-direction: row;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey2};
  border-radius: 4px;
  padding: 8px;
`;

export const ApplicationsStatusCounts = ({ applications }) => {
  const getApplicationStatusConfig = useGetApplicationStatusConfig();

  const statusCounts = (applications || [])
    .filter(({ shift }) => !!shift)
    .reduce(
      (acc, { status }) => {
        if (acc[status] !== undefined) {
          acc[status] = acc[status] + 1;
        }
        return acc;
      },
      { released: 0, pending: 0, booked: 0 }
    );

  return (
    <StatusCountsWrapper>
      {Object.entries(statusCounts).map(([status, count]) => {
        const { label, background, color } = getApplicationStatusConfig(status);

        return (
          <StatusCountItem key={status}>
            <StatusCountValue>{count}</StatusCountValue>
            <StatusChip label={label} background={background} color={color} />
          </StatusCountItem>
        );
      })}
    </StatusCountsWrapper>
  );
};
